import { Grid, Typography, useTheme } from "@mui/material";
import { AttachFileOutlined } from "@mui/icons-material";
import AnexosCircuito from "../anexosCircuito";
import useStyles from "./styles";

// Seção "Anexos" do formulário de circuito: fronteira que a etapa de hierarquia
// (fora deste plano) vai transformar na aba "Anexos" de fato — hoje ainda
// renderizada empilhada na mesma posição visual de antes. Extraída de
// circuito/index.js (Task 6 da decomposição), mesmo JSX/comportamento.
export default function AnexosTab({
  circuitoAnexos,
  setCircuitoAnexos,
  setDeletedAnexos,
  editMode,
  isActive,
  inputId,
  setSnackbar,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <>
      <Grid item xs={12} sx={styles.gritItemTitle}>
        <AttachFileOutlined color="primary" />
        <Typography variant="mySubtitle2">Anexos</Typography>
      </Grid>
      <Grid container spacing={1} sx={styles.contentIdentation}>
        <Grid item xs={12}>
          <AnexosCircuito
            circuitoAnexos={circuitoAnexos}
            setCircuitoAnexos={setCircuitoAnexos}
            setDeletedAnexos={setDeletedAnexos}
            editMode={editMode}
            isActive={isActive}
            inputId={inputId}
            setSnackbar={setSnackbar}
          />
        </Grid>
      </Grid>
    </>
  );
}
